import { Table, Text } from '@melio/penny';
import { Bill, Vendor } from '@melio/platform-api';
import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';
import { useMelioIntl } from '@melio/platform-i18n';

import { getTotalBillsBalance } from '../utils';
import { VendorsTabAmountInputCell } from './VendorsTabAmountInputCell';

export const VendorsTabOpenBalanceCell = ({
  vendor,
  unpaidBills,
  value,
  onAmountChange,
  onAddInvoiceClick,
}: {
  vendor: Vendor;
  unpaidBills: Bill[];
  value?: string;
  onAmountChange: (vendor: Vendor, value: string) => void;
  onAddInvoiceClick: (vendorId: Vendor['id'], amount?: string) => void;
}) => {
  const { formatCurrency } = useMelioIntl();
  const [isVendorsBatchPaymentsEnabled] = useFeature<boolean>(
    FeatureFlags.PlatformVendorsBatchNewPaymentsEnabled,
    false
  );

  const openBalance = getTotalBillsBalance(unpaidBills);
  return unpaidBills.length === 0 && isVendorsBatchPaymentsEnabled ? (
    <VendorsTabAmountInputCell
      value={value}
      vendor={vendor}
      onAmountChange={onAmountChange}
      onAddInvoiceClick={onAddInvoiceClick}
    />
  ) : (
    <Table.Cell data-testid={`vendors-tab-row-${vendor.id}-open-balance-cell`} textAlign="end">
      <Text textStyle="body3Semi" color={openBalance === 0 ? 'neutral.darker' : 'neutral.black'}>
        {formatCurrency(openBalance)}
      </Text>
    </Table.Cell>
  );
};
